import * as React from 'react';

import { ABTestCases, ABTestConfig } from './types';
import { defaultValues } from './defaultValues';

export interface ABTestingProviderValue {
  config: ABTestCases;
  trafficSlotNumber: number;
  title: string;
  variant: string;
}

interface ABTestingProviderProps {
  abTestConfig: ABTestConfig;
  e2eEnabled?: boolean;
}

export const ABTestingContext = React.createContext({} as ABTestingProviderValue);

const initialAbTestConfig: ABTestConfig = { title: '', variant: '', config: {} as any, trafficSlotNumber: 1 };

export const ABTestingProvider: React.FC<ABTestingProviderProps> = ({ abTestConfig, e2eEnabled = false, children }) => {
  const { config, trafficSlotNumber, title, variant } = abTestConfig || initialAbTestConfig;
  const value = React.useRef({
    title,
    variant,
    config: { ...defaultValues, ...(!e2eEnabled ? config : {}) },
    trafficSlotNumber,
  });
  return <ABTestingContext.Provider value={value.current}>{children}</ABTestingContext.Provider>;
};

export function useABTestingConfig() {
  const { config } = React.useContext(ABTestingContext);
  return config;
}

export function useABDistributionFactor() {
  const { trafficSlotNumber } = React.useContext(ABTestingContext);
  return trafficSlotNumber;
}
